<agr-page-toolbar
  [pageTitle]="'delivery.overview-title' | translate"
  data-test="deliveries-overview"
>
  <ng-container actions>
    <div
      class="flex--column spacing--padding-right padding-top-5"
      *ngIf="locationChipItems$ | async as locationChipItems"
    >
      <agr-chips-filter
        [multiple]="true"
        [items]="locationChipItems"
        (change)="changeLocation($event)"
        data-test="chip-locations"
      ></agr-chips-filter>
    </div>
  </ng-container>

  <app-page-table-filter
    [pageTitle]="'delivery.overview-title' | translate"
    [searchFieldPlaceholder]="'delivery.search-placeholder' | translate"
    [emptyTitle]="'delivery.empty-title' | translate"
    [emptyDescription]="'delivery.empty-description' | translate"
    [tableConfig]="tableConfig"
    [showTotals]="false"
    [showFilters]="false"
    [data$]="deliveryLines$"
    (loadDataCallback)="loadData()"
  >
  </app-page-table-filter>

  <ng-template #deliveredKgColumn let-row="row">
    @if (row.deliveredKg != null) {
      {{ row.deliveredKg | number: '1.0-3' }} kg
    } @else {
      {{ 'feed-balance.weight-unavailable' | translate }}
    }
  </ng-template>

  <ng-template #flockColumn let-row="row">
    {{ row.flock?.name }}
  </ng-template>

  <ng-template #isActiveColumn let-row="row">
    <mat-slide-toggle
      [hideIcon]="true"
      data-test="delivery-overview_toggle-active"
      color="primary"
      [checked]="row.isActive"
      [disabled]="updating()"
      (change)="onToggleActive(row, $event)"
    >
    </mat-slide-toggle>
  </ng-template>

  <ng-template #actionButtonsColumn let-row="row">
    <button
      mat-icon-button
      data-test="delivery-overview__edit-button"
      [disabled]="updating()"
      (click)="editFlockDelivery(row)"
    >
      <mat-icon>edit</mat-icon>
    </button>
  </ng-template>
</agr-page-toolbar>
